import React, { useState } from 'react';
import Modal from '../../Utilities/DraggableModal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import FuncFetch from '../../Utilities/funcFetch';
import { useMsal } from '@azure/msal-react';

const AddCollector = ({ show, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const { instance, accounts } = useMsal();
    const [formData, setFormData] = useState({
        collectorid: '',
        group: 'UM-UIM'
    });

    // Group options
    const groupOptions = ["UM-UIM", "Insurance", "Arbitration", "Admin"];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);
        
        FuncFetch(
            `${process.env.REACT_APP_API_URL}/Admin/PostCollector`,
            {
                ...formData,
            },
            'POST',
            null,
            instance,
            accounts
        )
        .then((response) => {
            setLoading(false);
            setSuccess('Collector added successfully!');
            setTimeout(() => {
                if (onSuccess) 
                onSuccess(response);
                onClose();
            }, 1500);
        })
        .catch((error) => {
            console.error('Error adding collector:', error);
            setLoading(false);
            setError('Failed to add collector. Please try again.');
        });
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Collector</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Collector ID</Form.Label>
                        <Form.Control
                            type="text"
                            name="collectorid"
                            value={formData.collectorid}
                            onChange={handleChange}
                            placeholder="JDoe"
                            required
                        />
                        <Form.Text className="text-muted">
                            Should be the same as the collector's email address prefix.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Group</Form.Label>
                        <Form.Select
                            name="group"
                            value={formData.group}
                            onChange={handleChange}
                            required
                        >
                            {groupOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Text className="text-muted">
                            Select the collector's group.
                        </Form.Text>
                    </Form.Group>

                    {loading && <Spinner animation="border" className="d-block mx-auto my-3" />}
                    {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
                    {success && <Alert variant="success" className="mt-3">{success}</Alert>}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button variant="primary" type="submit" disabled={loading}>
                            {loading ? 'Adding...' : 'Add Collector'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddCollector;